import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-survey-action-dialog',
  templateUrl: './survey-action-dialog.component.html',
  styleUrls: ['./survey-action-dialog.component.scss']
})
export class SurveyActionDialogComponent implements OnInit {
  form!: FormGroup;
  config!: any;

  constructor(
    public dialogRef: MatDialogRef<SurveyActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private baseService: BaseService
  ) {
    console.log('dialog data', data);
    this.form = fb.group({
      surveyResponseId: [null, Validators.compose([Validators.required])],
      orderType: [null, Validators.compose([])],
      orderNumber: [null, Validators.compose([])],
      sysproBranch: [null, Validators.compose([])],
      sysproSalesperson: [null, Validators.compose([])],
      salespersonNotes: [null, Validators.compose([Validators.required, Validators.maxLength(200)])],
      actionCategoryId: [null, Validators.compose([])]
    });

    this.form.controls['orderType'].disable();
    this.form.controls['orderNumber'].disable();
    this.form.controls['sysproBranch'].disable();
    this.form.controls['sysproSalesperson'].disable();
  }

  ngOnInit() {
    this.baseService
      .executeCommand<any>('portal_todo_survey_response_action_config', {
        surveyResponseId: this.data.callbackOrSurveyId,
      })
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.form.patchValue(response.data.initialFormValue);
          this.form.updateValueAndValidity();
          this.config = response.data;
        } else {
          this.dialogRef.close(undefined);
        }
      });
  }

  save(complete: boolean) {
    const fromValue = this.form.getRawValue();

    this.baseService
      .executeCommand<any>('portal_todo_survey_response_modify', Object.assign({complete: complete}, fromValue))
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        } else {
        }
      });
  }
}
